module.exports = __webpack_public_path__ + "img/total2.f3d6d4ce.png";